import { debounce } from 'lodash'
import { useCallback, useEffect, useRef } from 'react'

function useDebounce(cb, delay) {
	const options = { leading: false, trailing: true } // add custom lodash options
	const cbRef = useRef(cb)
	// use mutable ref to make useCallback/throttle not depend on `cb` dep
	useEffect(() => {
		cbRef.current = cb
	})
	return useCallback(
		debounce((...args) => cbRef.current(...args), delay, options),
		[delay]
	)
}

export { useDebounce }
